// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__eSJ6i","container-video":"App_container-video__dT1wr"};